angular.module('gantt.drawtask.templates', []).run(['$templateCache', function($templateCache) {

}]);
